/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';

import {MoneyValue} from '../../components/util/money';
import {Fee} from './fees-calculator';

interface NetworkFeeTranslations {
  getNetworkTranslations(key: string): string;
}

export interface SimplifiedFee extends Fee {
  id: string;
  name: string;
  type: string;
  monetary: MoneyValue;
}

export function getMatchingFee(
  fees: readonly MoneyValue[] | null | undefined,
  referenceCurrency: string
): MoneyValue | undefined {
  if (!fees?.length) {
    return undefined;
  }
  return fees.find(amount => amount.currency === referenceCurrency) || fees[0];
}

export function simplifyFee(
  LocalNetworkProfile: NetworkFeeTranslations,
  referenceCurrency: string,
  fee: Fee | null | undefined
): SimplifiedFee | undefined {
  const matchingFee = getMatchingFee(fee?.multiCurrencyMonetaryAmounts, referenceCurrency);
  if (!referenceCurrency || (referenceCurrency !== fee?.monetary?.currency && !matchingFee)) {
    return undefined;
  }

  const simplifiedFee = _.cloneDeep(fee) as SimplifiedFee;
  simplifiedFee.name = LocalNetworkProfile.getNetworkTranslations('creativeFormatFee');
  simplifiedFee.id = 'creative-format-fee';
  if (simplifiedFee.type === 'MULTI_CURRENCY_MONETARY' && matchingFee) {
    simplifiedFee.monetary = matchingFee;
  }
  return simplifiedFee;
}
